var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"class-name":"wuxing-compare3","title":"五行图辨证对比","width":"1100","mask-closable":false,"footer-hide":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[(_vm.show)?_c('wuxingCompare',{attrs:{"activeItem":_vm.activeItem,"isModal":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }